<template>
  <router-view></router-view>
</template>

<style lang="scss">
@import '~perfect-scrollbar/css/perfect-scrollbar.css';
@import '~socicon/css/socicon.css';
@import '~@fortawesome/fontawesome-free/css/all.css';
// @import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import 'assets/plugins/flaticon/flaticon.css';
// @import "assets/plugins/flaticon2/flaticon.css";
@import 'assets/plugins/keenthemes-icons/font/ki.css';
@import 'assets/font/iran-sans.css';
// Main demo style scss
// @import "assets/sass/style.vue";
@import 'assets/css/style.vue.rtl.css';

// Check documentation for RTL css
// Update HTML with RTL attribute at public/index.html
/*@import "assets/css/style.vue.rtl";*/
</style>

<script>
import { OVERRIDE_LAYOUT_CONFIG } from '@/core/services/store/config.module';

export default {
  name: 'App',
  mounted() {
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
  },
  head() {
    return {
      link: [
        {
          rel: 'icon',
          href: require(this.$store.getters.panelFavicon),
        },
      ],
      meta: {
        name: 'robots',
        content: 'noindex',
      },
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        document.title = to.meta.title || this.$store.getters.panelTitle;
      },
    },
  },
};
</script>
